import Navbar from "../components/Navbar/Navbar";
import { Header, Work, About, Skills, Footer } from "./index";
import { ThemeProvider } from "../ThemeContext";
import { useLocalStorage } from "../hooks/useLocalStorage";

const Main = () => {
  const darkPref = window.matchMedia("(prefers-color-scheme: dark)");

  const [darkMode, setDarkMode] = useLocalStorage("darkMode", darkPref.matches);

  return (
    <ThemeProvider value={{ darkMode, setDarkMode }}>
      <div>
        <Navbar />
        <Header />
        <About />
        <Work />
        <Skills />
        <Footer />
      </div>
    </ThemeProvider>
  );
};

export default Main;
